import { useState } from "react"
import useScrollReveal from "../../hooks/useScrollReveal"
import "./Awards.css"
import AWARDONE from "../../assets/AWARDONE.jpeg"
import AWARDTWO from "../../assets/AWARDTWO.jpeg"
import AWARDTHREE from "../../assets/AWARDTHREE.jpeg"
import AWARDFOUR from "../../assets/AWARDFOUR.jpeg"
import AWARDFIVE from "../../assets/AWARDFIVE.jpeg"
import AWARDSIX from "../../assets/AWARDSIX.jpeg"
import AWARDSEVEN from "../../assets/AWARDSEVEN.jpeg"
import AWARDEIGHT from "../../assets/AWARDEIGHT.jpeg"
import AWARDNINE from "../../assets/AWARDNINE.jpeg"

const awards = [AWARDONE, AWARDTWO, AWARDTHREE, AWARDFOUR, AWARDFIVE, AWARDSIX, AWARDSEVEN, AWARDEIGHT, AWARDNINE]

const Awards = ({ language }) => {
  useScrollReveal(".award-card")
  const [selectedAward, setSelectedAward] = useState(null)
  
  const awardsData = {
    en: [
      {
        title: "Governor of the Year (Education)",
        description:
          "In April 2025, the governor received this award from Blueprint Newspapers and Leadership Newspaper.",
      },
      {
        title: "NUT Golden Award",
        description:
          "In 2024, the Nigeria Union of Teachers (NUT) presented Governor Yusuf with this award for his performance in reforming the state's education sector.",
      },
      {
        title: "Recognition from Academic Institutions",
        description:
          "He was also honored by the Conference of Provosts for Colleges of Islamic Studies of Nigeria and the Management of Aminu Kano College of Islamic and Legal Studies for his commitment to education.",
      },
      {
        title: "Governor of the Year 2025 in Infrastructure Development",
        description:
          "The 15th African Achievers Awards, held in London, presented this award to Governor Yusuf in July 2025. The accolade recognized his transformative projects in road construction and urban renewal.",
      },
      {
        title: "Fellowship Award",
        description:
          "The Nigerian Institution of Civil Engineers (NICE) conferred a prestigious fellowship award on Governor Yusuf in October 2025. The award recognized his contributions to infrastructure development and excellence in engineering governance.",
      },
      {
        title: "Infrastructure Development Commendation Award",
        description: "The 19th African International Housing Show presented this award in August 2025.",
      },
      {
        title: "African Good Governance Award 2025",
        description:
          "In April 2025, the African Heritage Magazine recognized Governor Yusuf with this award for his visionary and people-centered leadership.",
      },
      {
        title: "Vanguard's 2024 Good Governance Award",
        description:
          "He was honored by Vanguard Newspaper in April 2025 for his commitment to institutionalizing good governance in Kano State.",
      },
      {
        title: "Managerial Support Award",
        description: "The Nigerian Institute of Management (NIM), Kano Chapter, presented this award in February 2025.",
      },
    ],
    ha: [
      {
        title: "Gwamna na Shekara (Ilimi)",
        description:
          "A cikin Afirilu 2025, gwamna ya karɓa wannan gida daga Blueprint Newspapers da Leadership Newspaper.",
      },
      {
        title: "NUT Golden Award",
        description:
          "A 2024, Nigeria Union of Teachers (NUT) ta ba da wannan gida ga Gwamna Yusuf saboda aiki da ya yi a gyara ilimin jihar.",
      },
      {
        title: "Gida daga Gidajen Ilimi",
        description:
          "An kuma gida shi ta Conference of Provosts for Colleges of Islamic Studies of Nigeria da Management of Aminu Kano College of Islamic and Legal Studies saboda ƙaura da ya yi ga ilimi.",
      },
      {
        title: "Gwamna na Shekara 2025 a Haɓaka Gida",
        description:
          "The 15th African Achievers Awards, da aka yi a London, ta ba da wannan gida ga Gwamna Yusuf a Janairu 2025. Gida ta gida ayyuka da ya yi a gina hanyoyi da sabuntawa gida.",
      },
      {
        title: "Gida na Fellowship",
        description:
          "Nigerian Institution of Civil Engineers (NICE) ta ba da gida mai daraja ga Gwamna Yusuf a Oktoba 2025. Gida ta gida abubuwan da ya ba da gudummawa a haɓaka gida da kyakkyawa a ilimin gida.",
      },
      {
        title: "Gida na Haɓaka Gida",
        description: "The 19th African International Housing Show ta ba da wannan gida a Agusta 2025.",
      },
      {
        title: "Gida na Kyakkyawa Mulki na Afirka 2025",
        description:
          "A cikin Afirilu 2025, African Heritage Magazine ta gida Gwamna Yusuf tare da wannan gida saboda jagorancin da ya yi da ƙaura ga jama'a.",
      },
      {
        title: "Gida na Kyakkyawa Mulki na Vanguard 2024",
        description:
          "Vanguard Newspaper ta gida shi a Afirilu 2025 saboda ƙaura da ya yi a tsara kyakkyawa mulki a Jihar Kano.",
      },
      {
        title: "Gida na Goyon Bayan Gudummawa",
        description: "Nigerian Institute of Management (NIM), Kano Chapter, ta ba da wannan gida a Fabrairun 2025.",
      },
    ],
  }

  const currentAwards = awardsData[language]

  return (
    <div className="awards">
      <div className="awards-header">
        <h1>{language === "en" ? "Awards & Recognition" : "Gidaje da Gida"}</h1>
      </div>

      <div className="awards-container">
        <div className="awards-list">
          {currentAwards.map((award, index) => (
            <div key={index} className="award-card scroll-reveal slide-left" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="award-number">{index + 1}</div>
              <h3>{award.title}</h3>
              <p>{award.description}</p>
            </div>
          ))}
        </div>

        <div className="awards-gallery">
          <h2>{language === "en" ? "Award Highlights" : "Gidajen Gida"}</h2>
          <div className="gallery-grid">
            {[...Array(9)].map((_, index) => (
              <div 
                key={index} 
                className="gallery-placeholder"
                onClick={() => setSelectedAward({ src: awards[index], index })}
              >
                <img
                  src={awards[index]}
                  alt={`Award ${index + 1}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {selectedAward && (
        <div className="awards-modal-overlay" onClick={() => setSelectedAward(null)}>
          <div className="awards-modal" onClick={(e) => e.stopPropagation()}>
            <button 
              className="awards-modal-close" 
              onClick={() => setSelectedAward(null)} 
              aria-label="Close"
            >
              ✕
            </button>
            <div className="awards-modal-content">
              <img 
                src={selectedAward.src} 
                alt={`Award ${selectedAward.index + 1}`}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Awards
